import { HttpClient } from '@angular/common/http';
import { Component, ElementRef, EventEmitter, Input, OnInit, Output, Provider, ViewChild } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { DomSanitizer } from '@angular/platform-browser';
import { AccessPointQueryParams, SpecificNaturalPerson } from 'src/app/_model/access-point-query-params';
import { DataServiceDirectoryQueryParams } from 'src/app/_model/data-service-directory-query-params';
import { Evidence } from 'src/app/_model/evidence';
import { EvidenceBrokerQueryParams } from 'src/app/_model/evidence-broker-query-params';
import { EvidenceProvider, EvidenceProviderClassification } from 'src/app/_model/evidence-provider';
import { AccessPointService } from 'src/app/_service/access-point.service';
import { DataServiceDirectoryService } from 'src/app/_service/data-service-directory.service';
import { EvidenceBrokerService } from 'src/app/_service/evidence-broker.service';
import { DEFAULT_DSD_QUERY_ID } from 'src/app/data-service-directory/constants';
import { QUERY_BY_REQUIREMENTS_AND_JURISDICTION } from 'src/app/evidence-broker/constants';
import { environment } from 'src/environments/environment';
import { LoaderButtonComponent } from '../loader-button/loader-button.component';
import { getNextNutsLevel } from 'src/app/contants';
import { TranslateService } from '@ngx-translate/core';
import { BreadcrumbService } from '../../_service/breadcrumb.service';
import { StateService } from 'src/app/_service/state.service';
import { JwtUtilsService } from 'src/app/_service/jwt-utils.service';
import { Requirement } from 'src/app/_model/requirement';
import { finalize, Subscription } from 'rxjs';
import { DocumentCounterService } from 'src/app/_service/document-counter.service';
import { EidasUser } from 'src/app/_model/eidasUser';
import { MultiLanguageStringPipe } from 'src/app/_model/multi-language-string';
import { EvidenceNotification } from 'src/app/_model/evidence-notification';
import { Utils } from '../utils';
import { OotsService } from 'src/app/_service/oots.service';
import { Select2Data, Select2UpdateEvent, Select2UpdateValue } from 'ng-select2-component';
import { CodeListElement } from 'src/app/_model/codeListElement';
import { EvidenceNotificationService } from 'src/app/_service/evidence-notification.service';
import { CountrySearchStatusEnum } from 'src/app/_model/country-search-status-enum';

const EVENTS_API_URL = environment.api_url + "/event";
declare const require: any;
const i18nIsoCountries = require("i18n-iso-countries");

@Component({
  selector: 'app-requirement',
  templateUrl: './requirement.component.html',
  styleUrls: ['./requirement.component.css']
})

export class RequirementComponent implements OnInit {
  @Input() ootsRequestId: string;
  @Input() requirement: Requirement;
  @Input() evidence: Evidence;
  @Output() selectedEvidenceListener: EventEmitter<Evidence> = new EventEmitter();
  @Output() evidenceListener: EventEmitter<Evidence> = new EventEmitter();
  @Output() countrySelected: EventEmitter<any> = new EventEmitter();
  @ViewChild(LoaderButtonComponent) sendButton?: LoaderButtonComponent;
  @ViewChild("documentPreview", { static: true }) documentPreview: ElementRef;

  private eventsSubscription = new Subscription();
  selectedCountry: Select2UpdateValue;
  countryList: Select2Data;
  isCountryListLoading = true;
  jurisdictionsList: Select2Data[];
  isProviderFound = false;
  isSearchDone = false;
  evidenceProviders: EvidenceProvider[];
  selectedProvider: EvidenceProvider;
  isRequestSent = false;
  private eventSource: EventSource;
  pdfBase64: string;
  isPdfAvailable: boolean | undefined = false;
  isPreview: boolean;
  errorMessage: string;
  base64Src: string;
  showJurisdictionSelect = false;
  isUserLogged = false;
  step: number;
  evidences: Evidence[];
  lang = "";
  requiredJurisdictionLevel: string;
  requiredEvidenceTypeId: string;
  jurisdictionContextId: string;
  classificationType: string;
  classificationTypes: string[];
  finalJurisdictionAdminL2: string;
  finalJurisdictionAdminL3: string;
  jurisdictionForm: FormGroup;
  dynamicJurisdictionSelects: FormControl[] = [];
  jurisdictionLists: any[];
  currentUser: EidasUser;
  receivedEvidence: Evidence;
  isAnyEvidenceReceived = false;
  isAnyEvidenceInProgress = false;
  isJurisdictionSelectActive = false;
  classsificationTypeCache: string;
  structuredData: string;
  jurisdictionSelectArray: FormArray[] = [];
  jurisdictionListsArrays: any[] = [];
  codeListsSelectArray: FormArray[] = [];
  codeListsListsArrays: any[] = [];
  countrySearchStatusEnum = CountrySearchStatusEnum;

  constructor(
    private ebService: EvidenceBrokerService,
    private dsdService: DataServiceDirectoryService,
    private apService: AccessPointService,
    private http: HttpClient,
    private sanitizer: DomSanitizer, private fb: FormBuilder,
    public translate: TranslateService,
    private breadcrumbService: BreadcrumbService,
    private stateService: StateService,
    private jwtUtilService: JwtUtilsService,
    private documentCounterService: DocumentCounterService,
    private multiLanguagePipe: MultiLanguageStringPipe,
    private ootsService: OotsService,
    private evidenceNotificationService: EvidenceNotificationService
  ) {

    this.eventsSubscription.add(
      this.stateService.getLanguage.subscribe(lang => {
        if (this.lang != lang) {
          this.changeCountryListLanguage(lang);
          this.lang = lang;
        }
      }));

    this.eventsSubscription.add(
      this.breadcrumbService.getStep.subscribe(step => {
        this.step = step;
        if (this.step === 2) {
          if (this.requirement) {
            this.requirement.selectedCountryCode = 'null';
            this.stateService.clearRequestStatus();
            this.stateService.requirementStatusChanged();
          }
        }
        if (this.step === 3 && this.requirement) {
          this.sincronizeDocumentsCounter();
          this.checkForEvidencesInProgress();
        }
      }));
  }

  ngOnInit(): void {

    i18nIsoCountries.registerLocale(require("i18n-iso-countries/langs/en.json"));
    i18nIsoCountries.registerLocale(require("i18n-iso-countries/langs/es.json"));
    this.jurisdictionForm = this.fb.group({
      select: ['']
    });
    this.isPreview = JSON.parse(this.stateService.isPreview());
    this.isUserLogged = this.jwtUtilService.isLogged();
    this.currentUser = this.jwtUtilService.getCurrentUser();

    this.checkForPreviewAvailable();
    this.initializeComponent();
    this.isCountryListLoading = true;
    this.ebService.fetchEvidenceCountriesByRequirementId(this.requirement.id, this.lang).subscribe(
      {
        next: result => {
          this.countryList = [];
          if (result) this.countryList = result.evidenceCountries.map((country: { code: string; name: string; }) => ({
            value: country.code,
            label: country.name,
            data: {
              image: "assets/country-flags/" + country.code.toLocaleLowerCase() + ".webp"
            }
          }));

          this.countryList.unshift({ value: "EU", label: "European Union Commision", data: { image: "assets/country-flags/eu.png" } });
          this.countryList.unshift({ value: "NONE", label: this.translate.instant('EV_REQUESTED.DISCARD_REQUIREMENT') });
          this.selectedCountry = "null";

          if (this.requirement.status === "DISCARDED") {
            this.requirement.selectedCountryCode = "NONE";
            this.selectedCountry = "NONE";
          }

          this.isCountryListLoading = false;

        },
        error: (e) => {
          this.countryList = [];
          this.isCountryListLoading = false;
          if(e.status === 404){
            this.requirement.countrySearchStatus = CountrySearchStatusEnum.NO_CS;
          }
          if(e.status === 406){
          this.countryList.unshift({ value: "NONE", label: this.translate.instant('EV_REQUESTED.DISCARD_REQUIREMENT') });
            this.requirement.countrySearchStatus = CountrySearchStatusEnum.NO_COUNTRIES;
          }
          this.stateService.requirementStatusChanged();
          console.log(e)
        }
      });

    this.jurisdictionsList = [];
    this.jurisdictionLists = [];
    this.stateService.validities.push('invalid')

    // Event subscriptions
    this.breadcrumbService.getStep.subscribe(step => { this.step = step; this.restart() });
    this.stateService.viewPdfMapObserver.subscribe(viewPdfMap => { this.showPdf(viewPdfMap) });
    // Sincronize documents counter
    this.sincronizeDocumentsCounter();
    this.checkForEvidencesInProgress();
  }

  showPdf(viewPdfMap: Map<string, boolean>) {

    if (viewPdfMap.get(this.requirement.id) != undefined) {
      if (viewPdfMap.get(this.requirement.id)) {
        setTimeout(() => {
          this.isPdfAvailable = true;
        }, 500)

      }
      else this.isPdfAvailable = false;
    }
    else this.isPdfAvailable = false;
  }

  getPlaceHolder() {
    return this.translate.instant('EV_REQUESTED.SELECT_COUNTRY');
  }

  sincronizeDocumentsCounter() {
    this.documentCounterService.resetCounters();
    this.documentCounterService.addDocumentsTotal(this.requirement.evidences.filter(ev => ev.status !== "CANCEL").length);
    if (this.requirement.evidences.length > 0) {
      const reqLength = this.requirement.evidences.filter(ev => ev.status === "RECEIVED").length;
      this.documentCounterService.addDocumentsReceived(reqLength);
    }
  }

  checkForEvidencesInProgress() {
     this.receivedEvidence = this.requirement.evidences.filter(ev => ev.status === "RECEIVED" || ev.status === "PREVIEW_AVAILABLE")[0];
    if (!Utils.isNullOrUndefined(this.receivedEvidence)) this.isAnyEvidenceInProgress = true;
  }

  checkForPreviewAvailable() {
    this.requirement.evidences.forEach(evidence => {
      if (evidence.status === "PREVIEW_AVAILABLE") this.waitForResponse(evidence);
    });
  }

  searchDocument(evidence: Evidence) {
    this.handleErrorEvidence(evidence);
    evidence = Object.assign(new Evidence(), evidence);
    const params = this.buildAccessPointQueryParams(evidence);
    this.sendAccessPointRequest(params);
  }

  handleErrorEvidence(evidence: Evidence) {
    if (evidence.status !== 'ERROR') return;
    this.documentCounterService.addDocumentTotal();
    if (evidence.evidenceUUID) {
      this.cancelEvidence(evidence);
      this.eventSource?.close();
    }
  }

  buildAccessPointQueryParams(evidence: Evidence): AccessPointQueryParams {
    const params = new AccessPointQueryParams();
    params.requestType = "REQUEST_1";
    params.ootsRequestId = this.ootsRequestId;
    params.evidenceUUID = evidence.evidenceUUID;
    params.evidenceIdentifier = evidence.evidenceIdentifier;
    params.evidenceTitle = this.multiLanguagePipe.transform(evidence.evidenceTitle, this.lang) ?? "";
    params.evidenceRequirementId = this.requirement.id;
    params.countryCode = this.requirement.selectedCountryCode !== "null" ? this.requirement.selectedCountryCode : evidence.countryCode;
    params.accessServiceIdentifier = evidence.accessServiceIdentifier ?? evidence.selectedProvider.accessServiceIdentifier;
    params.publisherName = evidence.publisherName ?? evidence.selectedProvider.publisherName;
    params.evidenceClassificationId = evidence.evidenceTypeClassification;
    params.skipPreview = !this.isPreview;
    params.specificNaturalPerson = this.buildSpecificNaturalPerson();
    params.requirementNumber = this.requirement.number;
    params.jurisdictionContextId = evidence.jurisdictionContextId;
    params.jurisdictionAdminL2 = evidence.jurisdictionAdminL2;
    params.jurisdictionAdminL3 = evidence.jurisdictionAdminL3;
    params.evidenceTypeId = evidence.dataServiceEvidenceTypeIdentifier;
    params.providerClassifications = this.buildProviderClassificationMap(evidence.selectedProvider.evidenceProviderClassifications);

    return params;
  }

  buildSpecificNaturalPerson(): SpecificNaturalPerson {
    const person = new SpecificNaturalPerson();
    person.birthDate = this.currentUser.dateOfBirth.toString().split('T')[0];
    person.givenName = this.currentUser.firstName;
    person.familyName = this.currentUser.familyName;
    person.userIdentifier = this.currentUser.personIdentifier;
    return person;
  }

  buildProviderClassificationMap(evidenceProviderClassifications : EvidenceProviderClassification[]): Record<string, string> | undefined{
    const providerClassifications: Record<string, string> = {};
    if(!evidenceProviderClassifications || evidenceProviderClassifications.length === 0){
      return undefined;
    }
    for(const evidenceProviderClassification of evidenceProviderClassifications){
      providerClassifications[evidenceProviderClassification.identifier] = evidenceProviderClassification.selectedValue;
    }
    return providerClassifications;
  }

  sendAccessPointRequest(params: AccessPointQueryParams) {
    this.isRequestSent = true;
    this.apService.sendRequest(params).subscribe({
      next: response => this.handleResponse(response),
      error: e => console.error(e)
    });
  }

  handleResponse(response: any) {
    console.info(response);
    const result = JSON.parse(response);

    if (result.success) {
      this.updateEvidences(result);
    } else {
      this.sendButton?.requestFinished();
      this.errorMessage = result.message;
    }
  }

  updateEvidences(result: any) {
    this.requirement.evidences.forEach(evidence => {
      if (evidence.evidenceIdentifier === result.evidenceIdentifier) {
        evidence.evidenceUUID = result.evidenceUUID;
        this.waitForResponse(evidence);
      }
    });
  }

  waitForResponse(evidence: Evidence) {
    this.stateService.loadingState = true;
    const subscription = this.evidenceNotificationService.evidenceListener.subscribe((notification: EvidenceNotification) => {
      if (notification.evidence.evidenceUUID !== evidence.evidenceUUID) return;
      this.handleNotification(evidence, notification);
      if (evidence.status === 'RECEIVED' || evidence.status === 'ERROR') {
        this.evidenceNotificationService.stopPolling(evidence.evidenceUUID);
        if (this.sendButton) this.sendButton.requestFinished();
        this.stateService.loadingState = false;
      }
    });

    this.eventsSubscription.add(subscription);
    this.evidenceNotificationService.waitForResponse(evidence);
  }

  private handleNotification(evidence: Evidence, notification: EvidenceNotification) {

    evidence.isPreview = notification.preview;
    evidence.status = notification.evidence.status;
    evidence.evidenceIdentifier = notification.evidence.evidenceIdentifier;
    evidence.evidenceNumber = parseInt(notification.evidence.evidenceNumber);

    if (!(evidence.evidenceTitle instanceof Array))
      evidence.evidenceTitle = [{ value: evidence.evidenceTitle, lang: "EN" }];

    evidence.countryCode = (this.requirement.selectedCountryCode && this.requirement.selectedCountryCode !== "null")
      ? this.requirement.selectedCountryCode
      : evidence.countryCode;

    evidence.requirementId = this.requirement.id;
    evidence.requirementNumber = this.requirement.number;

    if (evidence.isPreview) {
      evidence.previewUrl = notification.previewUrl;
    } else if (evidence.status === "ERROR") {
      evidence.errorMessage = notification.errorMessage;
      this.documentCounterService.removeDocumentTotal();
    } else if (evidence.status === "RECEIVED") {
      evidence.base64File = notification.evidence.base64File;
      evidence.fileName = notification.evidence.fileName;
      evidence.structuredData = notification.evidence.structuredData;
      this.documentCounterService.addDocumentReceived();
    }

    // Actualiza la evidencia en la lista del requirement
    const index = this.requirement.evidences.findIndex(ev => ev.evidenceUUID === evidence.evidenceUUID);
    if (index !== -1) this.requirement.evidences[index] = evidence;
    this.sendButton?.requestFinished();
    this.evidenceListener.emit(evidence);
    this.checkForEvidencesInProgress();
  }

  getClassificationType() {
    // call to EB to get the classification Id
    const queryParams: EvidenceBrokerQueryParams = {
      queryId: QUERY_BY_REQUIREMENTS_AND_JURISDICTION,
      countryCode: this.requirement.selectedCountryCode,
      requirementId: this.requirement.id
    };

    // mock to test against oots_test_platform
    if (this.selectedCountry == 'EU') return this.http.get("mocks/EUclassificationType.json");
    if (this.selectedCountry == 'ES2') return this.http.get("mocks/SGADclassificationType.json");

    //////////////////////////////////////////

    return this.ebService.getEvidenceClassification(queryParams);
  }

  getEvidenceProviders(classificationTypes: string) {

    // mock to test against oots_test_platform
    if (this.selectedCountry == 'EU') return this.http.get("mocks/EUevidenceProviders.json");
    if (this.selectedCountry == 'ES2') return this.http.get("mocks/SGADevidenceProviders.json");
    //////////////////////////////////////////

    // call to DSD to get the evidence providers
    const params: DataServiceDirectoryQueryParams = {
      queryId: DEFAULT_DSD_QUERY_ID,
      evidenceTypeClassification: classificationTypes,
      countryCode: this.selectedCountry.toString()
    }
    return this.dsdService.search(params);
  }

  searchEvidence() {
    this.isSearchDone = false;
    this.requirement.evidences = [];
    this.getClassificationType().subscribe({
      next: result => this.handleClassificationResult(result),
      error: () => { this.isSearchDone = true; }
    });
  }

  handleClassificationResult(result: any) {
    if (!result) {
      this.isSearchDone = true;
      this.errorMessage = this.translate.instant('LOCATE.ERROR_REQUIREMENT_NOT_FOUND');
      this.sendButton?.requestFinished();
      return;
    }

    if (result.success) {
      const evidenceTypesClassification = this.processClassificationType(result.classificationType);
      this.searchProviders(evidenceTypesClassification);
    } else {
      this.errorMessage = this.translateErrorMessage(result.message);
      this.sendButton?.requestFinished();
      this.isSearchDone = true;
    }
  }

  processClassificationType(classificationType: string[]): string {
    if (classificationType.length > 1) {
      this.classificationTypes = classificationType;
      return classificationType.join(',');
    } else {
      this.classificationType = classificationType[0];
      return classificationType[0];
    }
  }

  translateErrorMessage(message: string): string {
    if (message.includes("EB:ERR:0001")) return this.translate.instant('LOCATE.ERROR_REQUIREMENT_NOT_FOUND');
    else if (message.includes("EB:ERR:0002")) return this.translate.instant('LOCATE.ERROR_REQUIREMENT_ID_NONEXISTENT');
    return message;
  }

  searchProviders(classificationTypes: string) {
    this.clearJuristictionForm();
    this.getEvidenceProviders(classificationTypes)
      .pipe(finalize(() => { if (this.sendButton) this.sendButton.requestFinished(); }))
      .subscribe(
        {
          next: result => {
            this.isProviderFound = false;
            this.showJurisdictionSelect = false;
            this.requirement.providers = [];
            if (result.providers) {
              // Create a typed instance of Evidence[]
              result.providers.forEach((ep: EvidenceProvider) => {
                const provider = this.instantiateProvider(ep);
                this.requirement.providers.push(provider);
              });
              this.handleEvidenceProviders(this.requirement.providers)
              console.log(this.requirement.providers);
            }
          },
          error: (e) => {
            this.errorMessage = e.message;
            this.isSearchDone = true;
            this.isProviderFound = false;
            console.error(e)
          },

        }
      );
  }

  instantiateProvider(ep: EvidenceProvider): EvidenceProvider {
    const provider = new EvidenceProvider();
    provider.dataServiceEvidenceTypeIdentifier = ep.dataServiceEvidenceTypeIdentifier;
    provider.evidenceIdentifier = ep.evidenceIdentifier;
    provider.evidenceTitle = ep.evidenceTitle;
    provider.publisherName = ep.publisherName;
    provider.publisherIdentifier = ep.publisherIdentifier;
    provider.accessServiceIdentifier = ep.accessServiceIdentifier;
    provider.evidenceTypeClassification = ep.evidenceTypeClassification;
    provider.jurisdictionContextId = ep.jurisdictionContextId;
    provider.jurisdictionLevel = ep.jurisdictionLevel;
    provider.success = ep.success;
    provider.message = ep.message;
    provider.evidenceProviderClassifications = ep.evidenceProviderClassifications;
    provider.isValidProvider = true;
    provider.jurisdictionPosition = undefined;
    provider.errorMessage = undefined;
    return provider;
  }

  instantiateEvidence(ep: EvidenceProvider): Evidence {
    const evidence = new Evidence();
    evidence.dataServiceEvidenceTypeIdentifier = ep.dataServiceEvidenceTypeIdentifier;
    evidence.evidenceIdentifier = ep.evidenceIdentifier;
    evidence.evidenceTitle = ep.evidenceTitle;
    evidence.publisherName = ep.publisherName;
    evidence.publisherIdentifier = ep.publisherIdentifier;
    evidence.accessServiceIdentifier = ep.accessServiceIdentifier;
    evidence.evidenceTypeClassification = ep.evidenceTypeClassification;
    evidence.jurisdictionContextId = ep.jurisdictionContextId;
    evidence.jurisdictionLevel = ep.jurisdictionLevel;
    evidence.jurisdictionAdminL2 = ep.jurisdictionAdminL2;
    evidence.jurisdictionAdminL3 = ep.jurisdictionAdminL3;
    evidence.success = ep.success;
    evidence.message = ep.message;
    evidence.status = "PENDING";
    evidence.isPreview = true;
    evidence.requirementId = this.requirement.id;
    evidence.providers = [];
    return evidence;
  }

  addDynamicJurisdictionSelect(params: { nutsCodes?: NutsCode[], lauCodes?: LauCode[], currentLevel: string, index: number, provider: EvidenceProvider }) {
    this.isJurisdictionSelectActive = true;
    this.classsificationTypeCache = params.provider.evidenceTypeClassification;
    const jurisdictionSelect = this.fb.control('');
    const jurisdictionFormArray = this.jurisdictionSelectArray[params.index];
    if (jurisdictionFormArray && jurisdictionFormArray.length > 0) this.updateJurisdictionFormArray(jurisdictionFormArray, params, jurisdictionSelect);
    else this.initializeJurisdictionFormArray(params, jurisdictionSelect);
    this.subscribeJurisdictionChanges(jurisdictionSelect, params);
  }

  updateJurisdictionFormArray(jurisdictionFormArray: FormArray, params: any, jurisdictionSelect: any) {
    const lastLevel = jurisdictionFormArray.controls[jurisdictionFormArray.length - 1].get('jLevel')?.value;
    if ((params.currentLevel == 'LAU' && lastLevel != 'LAU') || parseInt(lastLevel) < parseInt(params.currentLevel)) {
      this.addJurisdictionFormGroup(jurisdictionFormArray, params.currentLevel, jurisdictionSelect);
    } else if (params.currentLevel == 'LAU' || parseInt(lastLevel) > parseInt(params.currentLevel)) {
      this.removeJurisdictionFormGroups(jurisdictionFormArray, params.currentLevel);
    }
  }

  initializeJurisdictionFormArray(params: any, jurisdictionSelect: any) {
    const jurisdictionFormGroup = this.fb.group({
      jLevel: params.currentLevel,
      selectedJurisdiction: jurisdictionSelect,
    });
    this.jurisdictionSelectArray.push(this.fb.array([jurisdictionFormGroup]));
  }

  addJurisdictionFormGroup(formArray: FormArray, level: string, control: any) {
    const formGroup = this.fb.group({
      jLevel: level,
      selectedJurisdiction: control,
    });
    formArray.push(formGroup);
  }

  removeJurisdictionFormGroups(formArray: FormArray, level: string) {
    while (parseInt(formArray.controls[formArray.length - 1].get('jLevel')?.value) > parseInt(level)) {
      formArray.removeAt(formArray.length - 1);
    }
  }

  subscribeJurisdictionChanges(jurisdictionSelect: any, params: any) {
    jurisdictionSelect.valueChanges.subscribe((value: string) => {
      if (params.currentLevel == this.requiredJurisdictionLevel) {
        this.handleSearchByLevel(value, params);
      } else {
        this.handleNextLevelFetch(value, params);
      }
    });
  }

  handleSearchByLevel(value: string, params: any) {
    switch (this.requiredJurisdictionLevel) {
      case "1":
      case "2":
      case "3":
        this.searchJurisdictionL2(value, params);
        break;
      case "LAU":
        this.searchJurisdictionL3(value, params);
        break;
    }
  }

  searchJurisdictionL2(value: string, params: any) {
    this.dsdService.search({
      queryId: DEFAULT_DSD_QUERY_ID,
      countryCode: this.selectedCountry.toString(),
      evidenceTypeClassification: params.provider.evidenceTypeClassification,
      jurisdictionAdminL2: value,
      evidenceTypeId: params.provider.evidenceIdentifier,
      jurisdictionContextId: params.provider.jurisdictionContextId
    }).subscribe({
      next: result => this.handleSearchResult(result, value),
      error: e => console.error(e)
    });
  }

  searchJurisdictionL3(value: string, params: any) {
    this.dsdService.search({
      queryId: DEFAULT_DSD_QUERY_ID,
      countryCode: this.selectedCountry.toString(),
      evidenceTypeClassification: this.classificationType,
      jurisdictionAdminL3: value,
      evidenceTypeId: params.provider.evidenceIdentifier,
      jurisdictionContextId: params.provider.jurisdictionContextId
    }).subscribe({
      next: result => this.handleSearchResult(result, value),
      error: e => console.error(e)
    });
  }

  handleSearchResult(result: any, value: string) {
    if (result.success) {
      result.providers.forEach((provider: EvidenceProvider) => this.updateProvider(provider, value));
      this.handleEvidenceProviders(this.requirement.providers);
    } else {
      this.errorMessage = result.message;
      this.isSearchDone = true;
      this.isProviderFound = false;
      console.log(result.message);
    }
  }

  updateProvider(provider: EvidenceProvider, value: string) {
    this.requirement.providers = this.requirement.providers.map(ep => {
      if (ep.evidenceIdentifier === null || ep.evidenceIdentifier === provider.evidenceIdentifier) {
        ep.success = provider.success;
        ep.jurisdictionLevel = provider.jurisdictionLevel;
        ep.jurisdictionAdminL2 = value;
        ep.jurisdictionAdminL3 = value;
        ep.accessServiceIdentifier = provider.accessServiceIdentifier;
        ep.publisherIdentifier = provider.publisherIdentifier;
        ep.publisherName = provider.publisherName;
        ep.isValidProvider = true;
        ep.message = provider.message;
      }
      return ep;
    });
  }

  handleNextLevelFetch(value: string, params: any) {
    const nextNutsLevel = getNextNutsLevel(params.currentLevel)?.key ?? '';
    if (!value) return;

    this.dsdService.fetchJurisdictionList(this.selectedCountry.toString(), nextNutsLevel, value).subscribe({
      next: result => this.handleNextLevelResult(result, params, nextNutsLevel),
      error: e => console.error(e)
    });
  }

  handleNextLevelResult(result: any, params: any, nextNutsLevel: string) {
    let resultJurisdiction: Select2Data = [];
    const nutsJurisdictions = (result as NutsCode[]);
    if (nutsJurisdictions) resultJurisdiction = nutsJurisdictions.map(j => ({ value: j.code, label: j.name }));
    this.jurisdictionsList.push(resultJurisdiction);

    if (result instanceof Array && result.every(item => 'nutsLevel' in item)) {
      this.addDynamicJurisdictionSelect({ nutsCodes: result, currentLevel: nextNutsLevel, index: params.index + 1, provider: params.provider });
    }
    if (result instanceof Array && result.every(item => 'nuts3Code' in item)) {
      this.addDynamicJurisdictionSelect({ lauCodes: result, currentLevel: nextNutsLevel, index: params.index + 1, provider: params.provider });
    }
  }

  handleEvidenceProviders(providers: EvidenceProvider[]) {
    this.isProviderFound = true;
    this.evidenceProviders = providers;

    let index = 0;

    this.evidenceProviders.forEach(provider => {
      this.isSearchDone = true;
      provider.errorMessage = undefined;

      if (this.evidenceProviders != null) {
        this.requirement.haveProviders = true;
        this.stateService.requirementStatusChanged();
      }

      if (!provider.success && this.selectedCountry !== "EU") {
        this.errorMessage = provider.message;
        this.classificationType = provider.evidenceTypeClassification;

        if (this.errorMessage?.includes("DSD:ERR:0005") && provider.jurisdictionLevel != null) {
          this.updateJurisdictionSelect(provider, index);
          index++;
        }
        else if (this.errorMessage?.includes("DSD:ERR:0005") && provider.evidenceProviderClassifications != null) {
          this.initializeProviderClassifications(provider);
        }
        else {
          this.handleProviderError(provider, this.errorMessage);
        }
      }
    });
  }

  updateJurisdictionSelect(provider: EvidenceProvider, index: number) {
    const jLevel: string = provider.jurisdictionLevel !== "LAU" ? provider.jurisdictionLevel.slice(-1) : "LAU";
    this.requiredJurisdictionLevel = jLevel;
    this.jurisdictionContextId = provider.jurisdictionContextId;
    this.requiredEvidenceTypeId = provider.dataServiceEvidenceTypeIdentifier;
    provider.isValidProvider = true;

    this.dsdService.fetchJurisdictionList(this.selectedCountry.toString(), jLevel).subscribe({
      next: result => {
        const jurisdictions = (result as any[]).map(j => ({ value: j.code, label: j.name }));
        if (this.jurisdictionListsArrays.length <= index) this.jurisdictionListsArrays.push([]);
        this.jurisdictionListsArrays[index][parseInt(jLevel) - 1] = jurisdictions;
        this.addDynamicJurisdictionSelect({ nutsCodes: result as NutsCode[], currentLevel: jLevel, index, provider });
        this.isProviderFound = this.evidenceProviders.some(p => p.isValidProvider);
      },
      error: e => console.error(e)
    });
  }

  initializeProviderClassifications(provider: EvidenceProvider) {
    provider.evidenceProviderClassifications.forEach(providerClassification => {
      if(providerClassification.type === 'codelist' && (!providerClassification.codeList || providerClassification.codeList.length == 0)){

        this.dsdService.fetchCodeList(providerClassification.valueExpresion).subscribe({
          next: result => {
            const codeListData = (result as CodeListElement[]).map(c => {
              let label: string;
              if (this.lang === 'es' && c.nameEs) label = c.nameEs;
              else if (this.lang === 'en' && c.nameEn) label = c.nameEn;
              else label = c.nameValue;
              return { value: c.code, label };
            });

            providerClassification.codeList = codeListData;
            this.isProviderFound = this.evidenceProviders.some(p => p.isValidProvider);
          },
          error: e => {
            provider.isValidProvider = false;
            provider.errorMessage = this.translate.instant('LOCATE.ERROR_PROVIDER_NOT_FOUND');
            console.error(e);
            this.isProviderFound = this.evidenceProviders.some(p => p.isValidProvider);
          }
        });
      }
      if(providerClassification.type === 'boolean'){
        providerClassification.selectedValue = false;
      }
    })
    
  }

  handleProviderError(provider: EvidenceProvider, errorMessage: string) {
    provider.isValidProvider = false;
    if (errorMessage.includes("EB:ERR:0001")) this.errorMessage = this.translate.instant('LOCATE.ERROR_REQUIREMENT_NOT_FOUND');
    else if (errorMessage.includes("EB:ERR:0002")) this.errorMessage = this.translate.instant('LOCATE.ERROR_REQUIREMENT_ID_NONEXISTENT');
    else if (errorMessage.includes("DSD:ERR:0001") || errorMessage.includes("DSD:ERR:0003")) {
      this.errorMessage = this.translate.instant('LOCATE.ERROR_REQUIREMENT_NOT_FOUND');
      provider.errorMessage = this.translate.instant('LOCATE.ERROR_REQUIREMENT_NOT_FOUND');
    }
    else if (errorMessage.includes("DSD:ERR:0002")) {
      this.errorMessage = this.translate.instant('LOCATE.ERROR_REQUIREMENT_ID_NONEXISTENT');
      provider.errorMessage = this.translate.instant('LOCATE.ERROR_REQUIREMENT_ID_NONEXISTENT');
    }
    else if (errorMessage.includes("DSD:ERR:0005")) {
      this.errorMessage = this.translate.instant('LOCATE.ERROR_PROVIDER_NOT_FOUND');
    }

    this.isProviderFound = this.evidenceProviders.some(p => p.isValidProvider);
  }

  searchEvidenceProviderClassification(requestProvider: EvidenceProvider){
    this.dsdService.search({
      queryId: DEFAULT_DSD_QUERY_ID, countryCode: this.selectedCountry.toString(),
      evidenceTypeClassification: requestProvider.evidenceTypeClassification, jurisdictionAdminL2: undefined,
      evidenceTypeId: requestProvider.evidenceIdentifier, jurisdictionContextId: undefined, providerClassifications: requestProvider.evidenceProviderClassifications
    }).subscribe(
      {
        next: result => {
          if (result.success) {
            result.providers.forEach((provider: EvidenceProvider) => {
              console.log(provider)
              // Modificar el elemento con el identificador específico
              this.requirement.providers = this.requirement.providers.map(ep => {
                if (ep.evidenceIdentifier === null || ep.evidenceIdentifier === provider.evidenceIdentifier) {
                  ep.success = provider.success;
                  ep.jurisdictionLevel = provider.jurisdictionLevel;
                  ep.accessServiceIdentifier = provider.accessServiceIdentifier;
                  ep.publisherIdentifier = provider.publisherIdentifier;
                  ep.publisherName = provider.publisherName;
                  ep.isValidProvider = true;
                  ep.message = provider.message;
                }
                return ep;
              });
            });
            this.handleEvidenceProviders(this.requirement.providers);
          }
          else {
            this.errorMessage = result.message;
            this.isSearchDone = true;
            this.isProviderFound = false;
            console.log(result.message);
          }
        },
        error: (e) => console.error(e)
      });
  }

  updateCodeList(event: Select2UpdateEvent<Select2UpdateValue>, providerIndex: number, epcIndex: number){
    this.requirement.providers[providerIndex].evidenceProviderClassifications[epcIndex].selectedValue = event.value.toString();
  }
//Might not be used
  codeListChange(event: Select2UpdateEvent<Select2UpdateValue>, providerCodeListIdentifier: string, requestProvider: EvidenceProvider) {
    console.log(providerCodeListIdentifier);
    console.log(event.value);

    this.dsdService.search({
      queryId: DEFAULT_DSD_QUERY_ID, countryCode: this.selectedCountry.toString(),
      evidenceTypeClassification: requestProvider.evidenceTypeClassification, jurisdictionAdminL2: undefined,
      evidenceTypeId: requestProvider.evidenceIdentifier, jurisdictionContextId: undefined,
    }).subscribe(
      {
        next: result => {
          if (result.success) {
            result.providers.forEach((provider: EvidenceProvider) => {
              console.log(provider)
              // Modificar el elemento con el identificador específico
              this.requirement.providers = this.requirement.providers.map(ep => {
                if (ep.evidenceIdentifier === null || ep.evidenceIdentifier === provider.evidenceIdentifier) {
                  ep.success = provider.success;
                  ep.jurisdictionLevel = provider.jurisdictionLevel;
                  ep.accessServiceIdentifier = provider.accessServiceIdentifier;
                  ep.publisherIdentifier = provider.publisherIdentifier;
                  ep.publisherName = provider.publisherName;
                  ep.isValidProvider = true;
                  ep.message = provider.message;
                }
                return ep;
              });
            });
            this.handleEvidenceProviders(this.requirement.providers);
          }
          else {
            this.errorMessage = result.message;
            this.isSearchDone = true;
            this.isProviderFound = false;
            console.log(result.message);
          }
        },
        error: (e) => console.error(e)
      });
  }

  providerSelected(provider: EvidenceProvider, providerIndex: number) {
    this.requirement.providers.forEach((provider, index) => {
      this.requirement.providers[index].isSelected = false;
      if (index === providerIndex) {
        this.requirement.providers[index].isSelected = true;
        this.requirement.evidences = [];
        const evidence = this.instantiateEvidence(this.requirement.providers[index]);
        evidence.providers.push(this.requirement.providers[index]);
        this.requirement.evidences.push(evidence);
      }
    });
    this.stateService.requirementStatusChanged();
  }

  viewDocument() {
    this.stateService.viewPdfMapChange(this.requirement.id, !this.isPdfAvailable);
  }

  deleteDocument(evidence: Evidence) {
    this.requirement = Object.assign(new Requirement(), this.requirement);
    this.ootsService.deleteEvidence(evidence.evidenceUUID).subscribe(
      {
        next: result => {
          if (result.success) {
            this.requirement.deleteEvidence(evidence.evidenceUUID);
            this.documentCounterService.removeDocumentReceived();
            this.stateService.ootsRequestModelChanged(this.ootsRequestId);
          }
          else console.log("Error eliminando la evidencia. " + result.message);
        },
        error: (e) => {
          console.error(e)
        },
      });
  }

  cancelEvidence(evidence: Evidence) {
    this.ootsService.cancelEvidence(evidence.evidenceUUID).subscribe(
      {
        next: result => {
          if (!result.success) console.log("Error cancelando la evidencia. " + result.message);
        },
        error: (e) => {
          console.error(e)
        },
      });
  }

  onCountryChange(event: Select2UpdateEvent<Select2UpdateValue>) {
    this.requirement.status = "PENDING";
    this.isJurisdictionSelectActive = false;
    this.showJurisdictionSelect = false;
    const countryCode = event.value;
    this.selectedCountry = countryCode.toString();
    this.isSearchDone = false;
    this.isProviderFound = false;
    this.requirement.evidences = [];
    this.requirement.selectedCountryCode = countryCode.toString();
    this.countrySelected.emit(countryCode.toString());
    if (this.evidences) {
      const evidencesReceived = this.evidences.some(evidence => evidence.status === "RECEIVED");
      if (evidencesReceived) this.requirement.status = "COMPLETED";
    }
    else {
      if (this.requirement.selectedCountryCode === "NONE") this.requirement.status = "DISCARDED";
      else this.requirement.status = "PENDING";
    }

    this.stateService.requirementStatusChanged();
  }

  onProviderChange(event: Event) {
    const providerId = (event.target as HTMLInputElement).value;
    const provider: EvidenceProvider = this.evidenceProviders.find(p => p.publisherIdentifier === providerId)!;
    this.selectedProvider = provider;
    this.isProviderFound = true;
    this.isSearchDone = true;
  }

  initializeComponent() {
    this.isRequestSent = false;
    this.selectedCountry = 'null';
    this.requirement.selectedCountryCode = 'null';
  }

  translateText(key: string) {
    return this.translate.instant(key);
  }

  onJurisdictionSubmit() {
    //
  }

  clearJuristictionForm() {
    this.requiredJurisdictionLevel = "";
    this.requiredEvidenceTypeId = "";
    this.jurisdictionContextId = "";
    this.classificationType = "";
    this.jurisdictionForm.reset();
    this.jurisdictionLists = [];
    this.dynamicJurisdictionSelects = [];
  }

  updateStep(newStep: number) {
    this.breadcrumbService.setStep(newStep)
  }

  setCancel(evidence: Evidence) {
    if (this.isRequestSent) {
      this.stateService.loadingState = false;
    }

    if (evidence.evidenceUUID) {
      this.cancelEvidence(evidence);
      if (this.eventSource) this.eventSource.close();
    }
    evidence.previousStatus = evidence.status;
    evidence.status = 'CANCEL';
    this.documentCounterService.removeDocumentTotal();
  }

  restart() {
    if (this.step === 2) {
      this.selectedCountry = "null";
      this.documentCounterService.resetDocumentsTotal();
      this.isProviderFound = false;
      this.isSearchDone = false;
      this.isRequestSent = false;
      this.showJurisdictionSelect = false;
      this.clearJuristictionForm();
    }
  }

  revertCancel(evidence: Evidence) {
    evidence.status = evidence.previousStatus !== undefined ? evidence.previousStatus : "PENDING";
    this.documentCounterService.addDocumentTotal();
  }

  changeCountryListLanguage(lang: string) {
    if (this.countryList !== undefined) {
      this.countryList.splice(0, 2);
      let countryName: any = "";
      for (const country of this.countryList) {
        const countryAny = country as any;
        const countryCode = countryAny.value as string !== "EL" ? countryAny.value as string : "GR";
        countryName = i18nIsoCountries.getName(countryCode, lang);
        if (countryName) country.label = countryName;
      }
      this.countryList.sort((a, b) => a.label.localeCompare(b.label));
      this.countryList.unshift({ value: "EU", label: "European Union Commision", data: { image: "assets/country-flags/eu.png" } });
      this.countryList.unshift({ value: "NONE", label: this.translate.instant('EV_REQUESTED.DISCARD_REQUIREMENT') });
    }
  }

  changeJurisdictionValue(event: Select2UpdateEvent<Select2UpdateValue>, position: number) {
    this.dynamicJurisdictionSelects[position].setValue(event.value);
  }

  changeJurisdictionValueNew(event: Select2UpdateEvent<Select2UpdateValue>, position: number, position2: number) {
    (this.jurisdictionSelectArray[position].controls[position2] as FormGroup).controls['selectedJurisdiction'].setValue(event.value);
    this.dynamicJurisdictionSelects[position].setValue(event.value);
  }

  showWarningForAdditionalInfo() {
    return this.requirement.providers[0].showJurisdictionSelect === true
      && this.requirement.providers[0].accessServiceIdentifier === null;
  }
}

export class NutsCode {
  code: string;
  name: string;
  countryCode: string;
  nutsLevel: string;
}

export class LauCode {
  code: string;
  name: string;
  countryCode: string;
  nuts3Code: string;
}